<template>

        <v-container
        class="scroll-y"
        fluid
        >
        <v-row
        align="center"
        justify="center"
        >
        <v-col cols="10" md="10">
          <v-card class="ml-20 mr-20">
            <v-app-bar
            dark
            color="#2C3A47"
            >
            <v-btn icon>
              <v-icon>mdi-lightbulb-group</v-icon>
            </v-btn>
          <v-toolbar-title>Group Setting</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" persistent max-width="800px">
            <template v-slot:activator="{ on }">
                <v-btn color="red" v-on="on" outlined="">
                  <v-icon left>add</v-icon> ADD
                </v-btn>
            </template>
              <v-card>
                <v-form @submit.prevent="saveGroup" ref="groupData" lazy-validation enctype="multipart/form-data" autocomplete="off">
                  <v-card-title>
                    <span class="headline">Group</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                      <v-flex xs12 sm12 md12>
                        <v-form ref="form" v-model="valid">
                        <v-text-field label="Name*" v-model="groupData.name" :rules="nameRules" color="#2C3A47"></v-text-field>
                        </v-form>
                      </v-flex>               
                    </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#2C3A47" dark @click="close" outlined small>
                      <v-icon left>exit_to_app</v-icon> Close
                    </v-btn>
                    <v-btn color="light-green darken-4" dark type="submit" outlined small>
                      <v-icon left>save</v-icon> {{saveDialog}}
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
          </v-dialog>
            </v-app-bar>
            <v-container>
              <v-card class="mx-auto elevation-19">
                <v-card-title>
                  <v-spacer></v-spacer>
                  <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                  color="#2C3A47"
                  >
                  </v-text-field>
                </v-card-title>
        <v-data-table
        item-key="id"
        :headers="headers"
        :items="group"
        :search="search"
        >

         <template v-slot:[`item.updatedAt`]="{ item }">
      {{ formatDate(item.updatedAt) }}
    </template>
        <template v-slot:[`item.actions`]="{item}">
          <v-btn color="success" fab x-small @click="editGroup(item)" outlined>
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          <v-btn color="pink" class="mx-2" fab x-small @click="deleteGroup(item._id)" outlined>
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </template>
        <template v-slot:no-results>
            <v-alert :value="true" color="pink" icon="warning" dark>
              Your Search {{search}} does not exist.
            </v-alert>
        </template>

        </v-data-table>
              </v-card>
            </v-container>
          </v-card>
          <v-snackbar
          v-model="snackbar"
          top
          right
          :color="color"
          >
          {{text}}
          <v-btn
          color="black"
          text
          @click="snackbar = false"
          >
          Dissmiss
          </v-btn>

          </v-snackbar>
        </v-col>

        </v-row>

        </v-container>
  
</template>
<script>
import axios from "axios";
import moment from 'moment';
export default {
  props:{
    source: String
  },
  data: () => ({
    mini: false,
    dialog:false,
    fab: false,
    search:'',
    snackbar: false,
    text:'',
    color:'',
    group: [],
    no: [],
    nameRules: [
        v => !!v || 'Name is required',
      ],
    headers: [
        {text: 'Name', value: 'name', sortable: true},
        {text: 'Modified By', value: 'modifiedBy', sortable: true},
        {text: 'Last Modified Date', value: 'updatedAt', sortable: true},
        {text: 'Action', value: 'actions', sortable: false, width: '180px'},
    ],
    groupData: {
      name: '',
      modifiedBy: ''
    },
    default: {
      name: '',
      modifiedBy: ''
    },
    editedIndex: -1,
  }),
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  computed: {
    saveDialog() {
      return this.editedIndex === -1 ? 'Save' : 'Edit'
    }
  },
  mounted() {
    this.loadsGroup();
    this.intervalFetchData();
  },
  methods: {
    intervalFetchData: function () {
            setInterval(() => {    
                this.loadsGroup()
                }, 5000);    
        },
    formatDate(value) {
      return moment(value).format("D MMM YYYY, h:mm:ss a")
  },
  loadsGroup: async function(){
  let apiURL = process.env.VUE_APP_API + "/api/group";
  axios.get(apiURL).then(res => {
    this.group = res.data;
    this.name = res.data.map((name) => name.name);
  }).catch(error => {
    console.log(error)
  });
},

    onScroll (e) {
      if(typeof window === 'undefined') return
      const top = window.pageYOffset || e.target.scrollTop || 0
      this.fab = top > 20
    },
    toTop(){
      this.$vuetify.goTo(0)
    },
    close(){
      this.dialog = false
      setTimeout(()=>{
        this.groupData = Object.assign({}, this.default)
        this.editedIndex = -1
      }, 300)
    },
    saveGroup: async function(){
        if(this.editedIndex > -1) {
         this.updateGroup();
        }else {
          this.createGroup();
        }
    },
    createGroup(){
      if (this.$refs.form.validate()) {
      let apiURL = process.env.VUE_APP_API + "/api/create-group";
      if(this.name.indexOf(this.groupData.name) >= 0){
        this.close();
        this.loadsGroup();
        this.color = 'warning'
        this.text =`Group ${this.groupData.name} already existed!!`
        this.snackbar = true;
      }
      else {
        axios.post(apiURL, {
        name: this.groupData.name,
        modifiedBy: this.$keycloak.tokenParsed.given_name
        }).then(() => {
          this.close();
          this.loadsGroup();
          this.color = 'success'
          this.text ='Group has been successfully saved.'
          this.snackbar = true;
        }).catch(error => {
          console.log(error)
        });
       }
    }},
    editGroup(item) {
      this.editedIndex = this.group.indexOf(item)
      this.groupData = Object.assign({}, item)
      this.dialog = true
    },
    updateGroup(){
      if (this.$refs.form.validate()) {
      let apiURL = process.env.VUE_APP_API + `/api/update-group/${this.groupData._id}`;
      axios.post(apiURL, {
        name: this.groupData.name,
        modifiedBy: this.$keycloak.tokenParsed.given_name
        }).then((res) => {
        console.log(res)
        this.close();
        this.loadsGroup();
        this.color ='info'
        this.text = 'Group has been modified.'
        this.snackbar = true;
      }).catch(error => {
        console.log(error)
        console.log(this.$route.params.id)
      })
    }},
     deleteGroup(id){
  this.$swal({
                    title: 'Are you sure?',
                    text: "You will not be able to go back",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#00b894',
                    cancelButtonColor: '#d63031',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    }).then((result) => {
                        // Send request to the server
                         if (result.value) {
                               try {
                let apiURL = process.env.VUE_APP_API + `/api/delete-group/${id}`;
                let indexOfArrayItem = this.group.findIndex(i => i._id === id);
                axios.delete(apiURL).then(() => {
                        this.group.splice(indexOfArrayItem, 1);
                    }).catch(error => {
                        console.log(error)
                    });
                 this.$swal(
                         'Deleted!',
                         'Group has been deleted.',
                         'success'
                        )
                        //Notification error
                this.color = 'error'
                this.text = "Group has been deleted."
                this.snackbar = true;
                //Notification error
            }catch (error) {
             this.$swal("Failed!", "There was something wrong.", "warning");
            }
                         }
                    })
  
            },
  },

}
</script>

<style>
  .otp-input {
    width: 30px;
    height: 40px;
    margin: 0 4px;
    font-size: 20px;
    border-radius: 2px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    text-align: center;

  }
  .otp-input::-webkit-inner-spin-button,
  .otp-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
</style>